module.exports = __webpack_public_path__ + "static/media/negative_event_response.ad412342.png";